export default "__VITE_ASSET__fce8efa5__"